export const FETCHING_ITEMS = "FETCHING_UPCOMING_CINEMA_MOVIES";
export const FETCHED_ITEMS = "FETCHED_UPCOMING_CINEMA_MOVIES";
export const RECEIVED_ITEMS = "RECEIVED_UPCOMING_CINEMA_MOVIES";
export const FETCHING_MORE_ITEMS = "FETCHING_MORE_UPCOMING_CINEMA_MOVIES";
export const FETCHED_MORE_ITEMS = "FETCHED_MORE_UPCOMING_CINEMA_MOVIES";
export const RECEIVED_MORE_ITEMS = "RECEIVED_MORE_UPCOMING_CINEMA_MOVIES";
export const UPDATED_FILTERS = "UPDATED_UPCOMING_CINEMA_FILTERS";
export const REPLACED_FILTERS = "REPLACED_UPCOMING_CINEMA_FILTERS";
